package fr.labodoc.healthProfessional.webApp.pages.contact

import fr.labodoc.healthProfessional.webApp.pages.contact.sections.ContactForm
import io.kvision.core.Container

fun Container.contactPage(): ContactForm {
  val contactForm = ContactForm()

  this.add(contactForm)
  return contactForm
}
